import { Settings as SettingsIcon } from "lucide-react";
import { PageHeader, Panel, DemoBadge, IntegrationCard } from "@/components/common";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { integrations } from "@/mocks/integrations";
import { currentUser } from "@/mocks/user";
import { demoAction } from "@/lib/demo";

export default function Settings() {
  return (
    <div className="space-y-6 animate-fade-up">
      <PageHeader icon={SettingsIcon} title="Configurações" description="Preferências da conta, organização e integrações da plataforma."
        breadcrumb={<><span>Organização</span><span>/</span><span className="text-foreground">Configurações</span></>}
        actions={<DemoBadge className="hidden sm:inline-flex" />} />

      <Tabs defaultValue="perfil">
        <TabsList className="flex h-auto w-full flex-wrap justify-start gap-1 border border-line bg-surface p-1">
          {[["perfil", "Perfil"], ["organizacao", "Organização"], ["integracoes", "Integrações"], ["notificacoes", "Notificações"]].map(([v, l]) => (
            <TabsTrigger key={v} value={v} data-testid={`settings-tab-${v}`} className="data-[state=active]:bg-brand data-[state=active]:text-white">{l}</TabsTrigger>
          ))}
        </TabsList>

        <TabsContent value="perfil" className="mt-5">
          <Panel title="Perfil" bodyClassName="max-w-lg space-y-4">
            <div className="space-y-1.5"><Label>Nome</Label><Input defaultValue={currentUser.name} className="border-line bg-surface" data-testid="settings-name" /></div>
            <div className="space-y-1.5"><Label>E-mail</Label><Input defaultValue={currentUser.email} className="border-line bg-surface" data-testid="settings-email" /></div>
            <div className="space-y-1.5"><Label>Cargo</Label><Input defaultValue={currentUser.role} disabled className="border-line bg-surface" /></div>
            <Button onClick={() => demoAction("Salvar perfil")} className="bg-brand text-white hover:bg-brand-hover" data-testid="settings-save">Salvar alterações</Button>
          </Panel>
        </TabsContent>

        <TabsContent value="organizacao" className="mt-5">
          <Panel title="Organização" bodyClassName="max-w-lg space-y-4">
            <div className="space-y-1.5"><Label>Nome da organização</Label><Input defaultValue="TintiCloud" className="border-line bg-surface" /></div>
            <div className="space-y-1.5"><Label>Domínio principal</Label><Input defaultValue="tinticloud.com" className="border-line bg-surface" /></div>
            <div className="space-y-1.5"><Label>Fuso horário</Label><Input defaultValue="America/Sao_Paulo" className="border-line bg-surface" /></div>
            <Button onClick={() => demoAction("Salvar organização")} className="bg-brand text-white hover:bg-brand-hover">Salvar</Button>
          </Panel>
        </TabsContent>

        <TabsContent value="integracoes" className="mt-5">
          <Panel title="Integrações" bodyClassName="grid gap-3 sm:grid-cols-2">
            {integrations.map((it) => <IntegrationCard key={it.id} integration={it} onOpen={() => demoAction(it.name)} />)}
          </Panel>
        </TabsContent>

        <TabsContent value="notificacoes" className="mt-5">
          <Panel title="Notificações" bodyClassName="max-w-lg space-y-3">
            {[["Alertas de infraestrutura", "Servidores offline, uso alto de recursos"], ["Deployments", "Sucesso e falha de deploys"], ["SSL & Domínios", "Expiração de certificados"], ["Backups", "Sucesso e falha de backups"]].map(([t, d]) => (
              <div key={t} className="flex items-center justify-between rounded-lg border border-line bg-white/[0.02] p-3">
                <div><p className="text-sm font-medium text-foreground">{t}</p><p className="text-xs text-muted-foreground">{d}</p></div>
                <Switch defaultChecked onCheckedChange={() => demoAction(t)} />
              </div>
            ))}
          </Panel>
        </TabsContent>
      </Tabs>
    </div>
  );
}
